<div class="modal-header">
  <h5 class="modal-title pull-left">
    <i class="fas fa-plus me-2"></i>
    <span style="font-size: 16px">Nuevo centro de costo</span>
  </h5>
  <button
    name="modalRef"
    type="button"
    class="btn-close pull-right"
    aria-label="Close"
    (click)="ModalRef.hide()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="max-height: 500px; overflow-y: auto">
  <div class="row">
    <div class="mb-3 col-md-6">
      <label for="codigo">Código</label>
      <input type="text" class="form-control" id="codigo" [(ngModel)]="code" />
    </div>
    <div class="mb-3 col-md-6">
      <label for="nombre">Nombre</label>
      <input
        type="text"
        class="form-control"
        id="nombre"
        maxlength="30"
        [(ngModel)]="name"
        autocomplete="off"
        (keyup)="cantCaracteres = name.length"
        (keydown)="cantCaracteres = name.length"
        (keypress)="cantCaracteres = name.length"
      />
      <div class="w-100 flex justify-content-end mt-1">
        <div class="max-caracteres">
          {{ cantCaracteres }} / {{ maxCaracteres }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    name="Cerrar"
    class="btn btn-link text-red-500 me-2"
    (click)="ModalRef.hide()"
  >
    Cancelar
  </button>
  <button
    name="Guardar"
    class="btn btn-secondary"
    [ngClass]="{ 'btn-loading': cargando }"
    (click)="guardar()"
  >
    Guardar
  </button>
</div>
